import { useGoogleDriveSource } from '@/modules/upload/cloud/google/useGoogleDriveSource'
import {
  CloudImportButton,
  type ProviderImportButtonProps,
} from './CloudImportButton'
import { GoogleDriveIcon } from './ProviderIcons'

export const GoogleDriveImportButton = (props: ProviderImportButtonProps) => {
  const source = useGoogleDriveSource()
  if (!source) return null
  return (
    <CloudImportButton source={source} icon={<GoogleDriveIcon />} {...props} />
  )
}
